import Vue from "vue";
import Router from "vue-router";

import menuRouter from "./menuRoutes";

Vue.use(Router);

const router = new Router({
  routes: [menuRouter],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const el = document.querySelector(to.hash);
          if (el) {
            const y =
              el.getBoundingClientRect().top + window.pageYOffset - 140;
            resolve({ x: 0, y: Math.max(0, y) });
          } else {
            resolve({ x: 0, y: 0 });
          }
        }, 350);
      });
    }
    return { x: 0, y: 0 };
  },
});

export default router;
